import { KycList } from "./KycList";
export default KycList;
